export default __webpack_public_path__ + "static/media/multi_color_star_1.b3edd4a3.svg";